import React, { useEffect, useState } from 'react';
import { getEstablishmentInfo, changeEstablishmentPassword } from '../services/api';
import './Settings.css';

export default function Settings() {
  const [settings, setSettings] = useState({
    siteName: '',
    contactEmail: 'support@valetparkingpro.com',
    maintenanceMode: false,
    logoUrl: 'https://via.placeholder.com/150',
    freeParkingDuration: 120,
    operatingHoursStart: '08:00',
    operatingHoursEnd: '22:00',
    termsAndConditions: 'By using this service, you agree to our terms and conditions.',
  });

  const [oldPass, setOldPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [saving, setSaving]   = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError]     = useState('');

  useEffect(() => {
    (async () => {
      try {
        const info = await getEstablishmentInfo(); // { id, name, created_at }
        setSettings((prev) => ({ ...prev, siteName: info.name }));
      } catch (e) {
        console.error(e);
        setError('Could not load establishment info');
      }
    })();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    setMessage('');
    setError('');
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    setError('');
    try {
      if (oldPass && newPass) {
        await changeEstablishmentPassword({
          old_password: oldPass,
          new_password: newPass,
        });
      }
      setMessage('Settings saved successfully!');
      setOldPass('');
      setNewPass('');
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.message || 'Failed to save settings. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page settings-page">
      <div className="page-head">
        <h2>Settings</h2>
        {settings.siteName && <span className="chip">Establishment: {settings.siteName}</span>}
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {message && <div className="alert alert-success">{message}</div>}

      <form onSubmit={handleSave} className="settings-form">
        {/* General */}
        <section className="card">
          <div className="card-head"><h3>General</h3></div>
          <div className="card-body grid-2">
            <label className="field">
              <span>Site Name</span>
              <input name="siteName" value={settings.siteName} onChange={handleChange} />
            </label>

            <label className="field">
              <span>Contact Email</span>
              <input type="email" name="contactEmail" value={settings.contactEmail} onChange={handleChange} />
            </label>

            <label className="field col-span-2">
              <span>Logo URL</span>
              <input name="logoUrl" value={settings.logoUrl} onChange={handleChange} />
            </label>

            <div className="preview col-span-2">
              <img src={settings.logoUrl} alt="Logo preview" />
            </div>

            <label className="switch col-span-2">
              <input
                type="checkbox"
                name="maintenanceMode"
                checked={settings.maintenanceMode}
                onChange={handleChange}
              />
              <span>Maintenance Mode</span>
            </label>
          </div>
        </section>

        {/* Parking */}
        <section className="card">
          <div className="card-head"><h3>Parking</h3></div>
          <div className="card-body">
            <label className="field">
              <span>Default Free Parking Duration (minutes)</span>
              <input type="number" name="freeParkingDuration" value={settings.freeParkingDuration} onChange={handleChange} />
            </label>
          </div>
        </section>

        {/* Operational */}
        <section className="card">
          <div className="card-head"><h3>Operational</h3></div>
          <div className="card-body grid-2">
            <label className="field">
              <span>Operating Hours Start</span>
              <input type="time" name="operatingHoursStart" value={settings.operatingHoursStart} onChange={handleChange} />
            </label>
            <label className="field">
              <span>Operating Hours End</span>
              <input type="time" name="operatingHoursEnd" value={settings.operatingHoursEnd} onChange={handleChange} />
            </label>
          </div>
        </section>

        {/* Legal */}
        <section className="card">
          <div className="card-head"><h3>Legal</h3></div>
          <div className="card-body">
            <label className="field">
              <span>Terms and Conditions</span>
              <textarea
                name="termsAndConditions"
                value={settings.termsAndConditions}
                onChange={handleChange}
                rows={6}
              />
            </label>
          </div>
        </section>

        {/* Passcode */}
        <section className="card">
          <div className="card-head"><h3>Change Establishment Passcode</h3></div>
          <div className="card-body grid-2">
            <label className="field">
              <span>Old Passcode</span>
              <input type="password" value={oldPass} onChange={(e) => setOldPass(e.target.value)} />
            </label>
            <label className="field">
              <span>New Passcode</span>
              <input type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} />
            </label>
          </div>
        </section>

        <div className="form-actions">
          <button className="btn btn-ghost" type="button" onClick={() => window.location.reload()}>Cancel</button>
          <button className="btn btn-primary" type="submit" disabled={saving}>
            {saving ? 'Saving…' : 'Save Settings'}
          </button>
        </div>
      </form>
    </div>
  );
}
